const areas = [{
    name : 'busyStreet',
    y : 0,
    p : [{
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M11.3,112.2h1v3.1c0.2-0.3,0.5-0.5,0.8-0.7s0.7-0.2,1-0.2c0.8,0,1.4,0.3,1.9,0.8s0.7,1.3,0.7,2.4c0,1-0.2,1.8-0.7,2.5s-1.2,1-2,1c-0.5,0-0.9-0.1-1.2-0.3c-0.2-0.1-0.4-0.4-0.6-0.7v0.8h-1V112.2z M15.3,119.4c0.3-0.5,0.4-1.1,0.4-1.8c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.4-0.7-0.7-1.3-0.7c-0.5,0-0.9,0.2-1.3,0.5c-0.4,0.4-0.5,0.9-0.5,1.8c0,0.6,0.1,1.1,0.2,1.4c0.3,0.7,0.8,1,1.6,1C14.6,120.1,15.1,119.9,15.3,119.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M19.1,114.6v4.2c0,0.3,0.1,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1H23v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H19.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M25.4,118.9c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.7-0.1,1.1-0.3c0.3-0.2,0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4s1-0.6,1.8-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6c-0.4-0.4-0.6-0.9-0.6-1.6H25.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M34.7,114.6h1.2c-0.1,0.4-0.5,1.3-1,2.8c-0.4,1.1-0.7,2-1,2.6c-0.6,1.6-1,2.6-1.3,2.9c-0.2,0.4-0.7,0.5-1.3,0.5c-0.1,0-0.3,0-0.3,0s-0.2,0-0.3-0.1v-1c0.2,0.1,0.3,0.1,0.4,0.1s0.2,0,0.2,0c0.2,0,0.3,0,0.4-0.1s0.2-0.1,0.2-0.2c0,0,0.1-0.2,0.2-0.5c0.1-0.3,0.2-0.5,0.3-0.6l-2.3-6.5h1.2l1.7,5.1L34.7,114.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M40.7,118.9c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.8-0.1,1.1-0.3s0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4s1-0.6,1.7-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4s-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6c-0.4-0.4-0.6-0.9-0.6-1.6H40.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M46.3,112.8h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V112.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M49.5,114.6h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V114.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M57.3,114.7c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5s0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9s-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5s1.3-0.9,2.1-0.9C56.4,114.4,56.9,114.5,57.3,114.7z M57.7,117.2c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.8-0.5,1.3H57.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M64,114.7c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5s0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9s-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5s1.3-0.9,2.1-0.9C63.1,114.4,63.6,114.5,64,114.7z M64.3,117.2c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.8-0.5,1.3H64.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M67,112.8H68v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9H67V112.8z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2386_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2511_',
            'opacity' : '0.5'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2512_',
            'class' : 'origins-highlight-area',
            'd' : 'M72.1,45.4v-9.4c0-2.2-1.8-4-4-4H68c-2.2,0-4-1.8-4-4v-7.5c0-2.2-1.8-4-4-4H34.7c-2.2,0-4-1.8-4-4l0,0c0-2.2-1.8-4-4-4H4.2c-2.2,0-4,1.8-4,4v33.1H72.1z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2509_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2510_',
            'fill' : '#00B9ED',
            'd' : 'M65.9,105.9H6.6c-3.6,0-6.4-2.9-6.4-6.4V51.2c0-3.6,2.9-6.4,6.4-6.4h59.3c3.6,0,6.4,2.9,6.4,6.4v48.3C72.3,103,69.4,105.9,65.9,105.9z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2507_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2508_',
            'fill' : '#FDFCFF',
            'd' : 'M65.9,103.6H6.6c-3.6,0-6.4-2.9-6.4-6.4V47.3c0-3.6,2.9-6.4,6.4-6.4h59.3c3.6,0,6.4,2.9,6.4,6.4v49.9C72.3,100.8,69.4,103.6,65.9,103.6z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2506_',
            'y' : '72',
            'fill' : '#DEE0E2',
            'width' : '72.1',
            'height' : '23.8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2505_',
            'x' : '0.2',
            'y' : '83.2',
            'fill' : '#FDFCFF',
            'width' : '3.1',
            'height' : '1.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2504_',
            'x' : '0.2',
            'y' : '73.7',
            'fill' : '#FDFCFF',
            'width' : '72.1',
            'height' : '1.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2503_',
            'x' : '0.2',
            'y' : '93',
            'fill' : '#FDFCFF',
            'width' : '72.1',
            'height' : '1.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2502_',
            'x' : '15.7',
            'y' : '83.2',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '1.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2501_',
            'x' : '36.9',
            'y' : '83.2',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '1.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2500_',
            'x' : '56.8',
            'y' : '83.2',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '1.2'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2485_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2499_',
            'fill' : '#FDFCFF',
            'points' : '45.1,66 25.5,66 25.5,58.4 35.3,51.3 45.1,58.4 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2498_',
            'fill' : '#DEE0E2',
            'points' : '35.3,66 25.5,66 25.5,58.4 35.3,51.3 '
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2497_',
            'fill' : '#FDFCFF',
            'd' : 'M32.7,32.4h27.8c0.6,0,1.1-0.5,1.1-1.1l0,0c0-0.6-0.5-1.1-1.1-1.1h-5c-0.6,0-1.1-0.5-1.1-1.1v-6.2c0-0.6-0.5-1.1-1.1-1.1h-9c-0.6,0-1.1,0.5-1.1,1.1v1.9c0,0.6-0.5,1.1-1.1,1.1h-3.7c-0.6,0-1.1,0.5-1.1,1.1v0.9c0,0.6-0.5,1.1-1.1,1.1h-3.6c-0.6,0-1.1,0.5-1.1,1.2l0.1,1.2C31.6,32,32.1,32.4,32.7,32.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2496_',
            'fill' : '#00B9ED',
            'd' : 'M34.6,38.5l-9.1,6.6v13.3l9.1-6.6c0.4-0.3,1-0.3,1.4,0l9.1,6.6V45.1L36,38.5C35.6,38.2,35,38.2,34.6,38.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2495_',
            'fill' : '#004A7A',
            'd' : 'M35.3,51.6c0.2,0,0.5,0.1,0.7,0.2l9.1,6.6V45.1L36,38.5c-0.2-0.2-0.5-0.2-0.7-0.2L35.3,51.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2494_',
            'fill' : '#DEE0E2',
            'd' : 'M64.8,66l7.5-6.4c0,0,0-9.3,0-12.2s-0.8-6.4-3.9-6.4s-9.5,0-9.5,0L64.8,66z'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2493_',
            'fill' : '#FDFCFF',
            'points' : '64.8,66 45.1,66 45.1,58.4 55,51.3 64.8,58.4 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2492_',
            'fill' : '#DEE0E2',
            'points' : '55,66 45.1,66 45.1,58.4 55,51.3 '
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2491_',
            'fill' : '#00B9ED',
            'd' : 'M54.3,38.5l-9.1,6.6v13.3l9.1-6.6c0.4-0.3,1-0.3,1.4,0l9.1,6.6V45.1l-9.1-6.6C55.3,38.2,54.7,38.2,54.3,38.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2490_',
            'fill' : '#004A7A',
            'd' : 'M55,51.6c0.2,0,0.5,0.1,0.7,0.2l9.1,6.6V45.1l-9.1-6.6c-0.2-0.2-0.5-0.2-0.7-0.2L55,51.6z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2489_',
            'x' : '6.8',
            'y' : '4.7',
            'fill' : '#FDFCFF',
            'width' : '18.7',
            'height' : '16.8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2488_',
            'x' : '13.5',
            'y' : '12.3',
            'fill' : '#00B9ED',
            'width' : '5.2',
            'height' : '4.7'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2487_',
            'x' : '13.5',
            'y' : '7.6',
            'fill' : '#FDFCFF',
            'width' : '5.2',
            'height' : '4.7'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2486_',
            'fill' : '#05A4D2',
            'points' : '25.5,58.4 35.2,42.2 35.2,37.9 25.5,45.1 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2484_',
            'fill' : '#DEE0E2',
            'points' : '18.7,17 22.3,13.4 22.3,9.5 18.7,9.5 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2483_',
            'x' : '32.8',
            'y' : '58.2',
            'fill' : '#00B9ED',
            'width' : '4.6',
            'height' : '7.7'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2482_',
            'x' : '52.8',
            'y' : '58.2',
            'fill' : '#00B9ED',
            'width' : '4.6',
            'height' : '7.7'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2481_',
            'fill' : '#004A7A',
            'points' : '37.4,59.9 34.4,59.9 33,58.3 38.4,56.6 37.4,58.3 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2480_',
            'x' : '31.9',
            'y' : '56.6',
            'fill' : '#FDFCFF',
            'width' : '6.5',
            'height' : '1.5'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2479_',
            'fill' : '#004A7A',
            'points' : '57.4,59.9 54.4,59.9 53,58.3 58.4,56.6 57.4,58.3 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2478_',
            'x' : '51.9',
            'y' : '56.6',
            'fill' : '#FDFCFF',
            'width' : '6.5',
            'height' : '1.5'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2477_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '44.3',
            'y1' : '56.3',
            'x2' : '55.1',
            'y2' : '48.8'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2476_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '44.3',
            'y1' : '53.6',
            'x2' : '55.1',
            'y2' : '46.1'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2475_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '44.3',
            'y1' : '50.9',
            'x2' : '55.1',
            'y2' : '43.4'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2474_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '44.3',
            'y1' : '48.2',
            'x2' : '55.1',
            'y2' : '40.7'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2473_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '25.4',
            'y1' : '56.3',
            'x2' : '36.1',
            'y2' : '48.8'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2472_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '25.4',
            'y1' : '53.6',
            'x2' : '36.1',
            'y2' : '46.1'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2471_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '25.4',
            'y1' : '50.9',
            'x2' : '36.1',
            'y2' : '43.4'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2470_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '25.4',
            'y1' : '48.2',
            'x2' : '36.1',
            'y2' : '40.7'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2469_',
            'x' : '6.8',
            'y' : '21.5',
            'fill' : '#DEE0E2',
            'width' : '18.7',
            'height' : '44.6'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2462_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2468_',
            'x' : '9.2',
            'y' : '25.4',
            'fill' : '#00B9ED',
            'width' : '5.4',
            'height' : '5.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2467_',
            'x' : '17.5',
            'y' : '25.4',
            'fill' : '#00B9ED',
            'width' : '5.4',
            'height' : '5.4'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2466_',
            'fill' : '#004A7A',
            'points' : '14.5,27.1 10.6,27.1 9.2,25.5 15.4,23.8 14.5,25.5 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2465_',
            'x' : '8.2',
            'y' : '23.3',
            'fill' : '#FDFCFF',
            'width' : '7.3',
            'height' : '2'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2464_',
            'fill' : '#004A7A',
            'points' : '22.7,27.1 18.8,27.1 17.4,25.5 23.7,23.8 22.7,25.5 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2463_',
            'x' : '16.5',
            'y' : '23.3',
            'fill' : '#FDFCFF',
            'width' : '7.3',
            'height' : '2'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2455_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2461_',
            'x' : '9.2',
            'y' : '34.9',
            'fill' : '#00B9ED',
            'width' : '5.4',
            'height' : '5.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2460_',
            'x' : '17.5',
            'y' : '34.9',
            'fill' : '#00B9ED',
            'width' : '5.4',
            'height' : '5.4'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2459_',
            'fill' : '#004A7A',
            'points' : '14.5,36.5 10.6,36.5 9.2,35 15.4,33.3 14.5,35 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2458_',
            'x' : '8.2',
            'y' : '32.8',
            'fill' : '#FDFCFF',
            'width' : '7.3',
            'height' : '2'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2457_',
            'fill' : '#004A7A',
            'points' : '22.7,36.5 18.8,36.5 17.4,35 23.7,33.3 22.7,35 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2456_',
            'x' : '16.5',
            'y' : '32.8',
            'fill' : '#FDFCFF',
            'width' : '7.3',
            'height' : '2'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2448_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2454_',
            'x' : '9.2',
            'y' : '44.4',
            'fill' : '#00B9ED',
            'width' : '5.4',
            'height' : '5.4'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2453_',
            'x' : '17.5',
            'y' : '44.4',
            'fill' : '#00B9ED',
            'width' : '5.4',
            'height' : '5.4'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2452_',
            'fill' : '#004A7A',
            'points' : '14.5,46 10.6,46 9.2,44.5 15.4,42.8 14.5,44.5 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2451_',
            'x' : '8.2',
            'y' : '42.3',
            'fill' : '#FDFCFF',
            'width' : '7.3',
            'height' : '2'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2450_',
            'fill' : '#004A7A',
            'points' : '22.7,46 18.8,46 17.4,44.5 23.7,42.8 22.7,44.5 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2449_',
            'x' : '16.5',
            'y' : '42.3',
            'fill' : '#FDFCFF',
            'width' : '7.3',
            'height' : '2'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2441_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2447_',
            'x' : '9.2',
            'y' : '53.8',
            'fill' : '#00B9ED',
            'width' : '5.4',
            'height' : '11.9'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2446_',
            'x' : '17.5',
            'y' : '53.8',
            'fill' : '#00B9ED',
            'width' : '5.4',
            'height' : '5.4'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2445_',
            'fill' : '#004A7A',
            'points' : '14.5,55.5 10.6,55.5 9.2,54 15.4,52.3 14.5,54 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2444_',
            'x' : '8.2',
            'y' : '51.8',
            'fill' : '#FDFCFF',
            'width' : '7.3',
            'height' : '2'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2443_',
            'fill' : '#004A7A',
            'points' : '22.7,55.5 18.8,55.5 17.4,54 23.7,52.3 22.7,54 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2442_',
            'x' : '16.5',
            'y' : '51.8',
            'fill' : '#FDFCFF',
            'width' : '7.3',
            'height' : '2'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2440_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '9.8',
            'y1' : '7.5',
            'x2' : '9.8',
            'y2' : '0'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_2439_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '22.7',
            'y1' : '7.5',
            'x2' : '22.7',
            'y2' : '0'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2411_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2438_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'd' : 'M21.5,89.4c2.9,0,3-2.7,3-2.7h2.2l1.4-1.4c0,0,0-2.2,0-3.5c0-1.2-2.1-4.5-4.5-4.5c-2.4,0-0.6,0-0.6,0l-2.8-3.4h-9.1l-3.5,2.8l1,8.2l0.5,4.4c0,0,3.5,1.4,4.5-2.9l6.2-0.2L21.5,89.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2437_',
            'fill' : '#00B9ED',
            'd' : 'M24,86.6L6.3,82.3v-3.4h15c1.5,0,2.7,1.2,2.7,2.7V86.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2436_',
            'fill' : '#00B9ED',
            'd' : 'M6.3,78.8l4.1,1l9.2-1l-2.3-3.4H9c-1.5,0-2.7,1.2-2.7,2.7V78.8z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2435_',
            'x' : '5.6',
            'y' : '81.7',
            'fill' : '#00B9ED',
            'width' : '19',
            'height' : '4.5'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2434_',
            'fill' : '#004A7A',
            'd' : 'M24,86.6H6.3v-3.4h14.3C22.5,83.2,24,84.7,24,86.6L24,86.6z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2433_',
            'x' : '5.6',
            'y' : '86.2',
            'fill' : '#004A7A',
            'width' : '19',
            'height' : '1.4'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2432_',
            'fill' : '#004A7A',
            'd' : 'M6.3,83.2l4.1,1l9.2-1l-2.3-3.4H9c-1.5,0-2.7,1.2-2.7,2.7V83.2z'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2431_',
            'fill' : '#004A7A',
            'cx' : '9.1',
            'cy' : '87.4',
            'r' : '1.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2430_',
            'fill' : '#004A7A',
            'cx' : '21.2',
            'cy' : '87.4',
            'r' : '1.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2429_',
            'fill' : '#FFFFFF',
            'cx' : '9.1',
            'cy' : '87.6',
            'r' : '0.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2428_',
            'fill' : '#FFFFFF',
            'cx' : '21.2',
            'cy' : '87.6',
            'r' : '0.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2427_',
            'fill' : '#004A7A',
            'cx' : '36.4',
            'cy' : '87.4',
            'r' : '1.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2426_',
            'fill' : '#004A7A',
            'cx' : '41.1',
            'cy' : '87.4',
            'r' : '1.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2423_',
            'fill' : '#004A7A',
            'cx' : '50.5',
            'cy' : '87.4',
            'r' : '1.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2422_',
            'fill' : '#004A7A',
            'cx' : '54.7',
            'cy' : '87.4',
            'r' : '1.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2419_',
            'fill' : '#004A7A',
            'cx' : '60.8',
            'cy' : '87.4',
            'r' : '1.9'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2414_',
            'fill' : '#FDFCFF',
            'points' : '17.4,79.7 17.4,75.4 19.6,78.8 19.6,83.2 '
        }
    }, {
        'type' : 'polyline',
        'properties' : {
            'id' : 'XMLID_2406_',
            'fill' : '#00B9ED',
            'points' : '36.4,80 59.5,80 59.5,84 36.4,84 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2403_',
            'x' : '57.9',
            'y' : '70.9',
            'fill' : '#00B9ED',
            'width' : '3.9',
            'height' : '7.7'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2400_',
            'fill' : '#FDFCFF',
            'points' : '61.8,78.6 64.7,81.7 64.7,74 61.8,70.9 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2399_',
            'fill' : '#004A7A',
            'points' : '64.7,87 57.9,87 57.9,78.6 61.8,78.6 64.7,81.7 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2398_',
            'x' : '33.2',
            'y' : '84.1',
            'fill' : '#004A7A',
            'width' : '11.2',
            'height' : '3.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2397_',
            'fill' : '#FFFFFF',
            'cx' : '36.5',
            'cy' : '87.6',
            'r' : '0.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2395_',
            'fill' : '#FFFFFF',
            'cx' : '41.1',
            'cy' : '87.6',
            'r' : '0.9'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2394_',
            'x' : '47.6',
            'y' : '84.1',
            'fill' : '#004A7A',
            'width' : '11.9',
            'height' : '3.9'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2392_',
            'x' : '32.6',
            'y' : '69.4',
            'fill' : '#00B9ED',
            'width' : '23.6',
            'height' : '7.7'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2391_',
            'x' : '32.6',
            'y' : '77.1',
            'fill' : '#004A7A',
            'width' : '23.6',
            'height' : '8.6'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2390_',
            'fill' : '#FFFFFF',
            'cx' : '50.4',
            'cy' : '87.6',
            'r' : '0.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2389_',
            'fill' : '#FFFFFF',
            'cx' : '54.8',
            'cy' : '87.6',
            'r' : '0.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2387_',
            'fill' : '#FFFFFF',
            'cx' : '60.9',
            'cy' : '87.6',
            'r' : '0.9'
        }
    }]
}, {
    name : 'quietStreet',
    y : 142,
    p : [{
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M9.5,115.5c0.2,0.1,0.4,0.3,0.6,0.6v-0.9h1v8.8H10v-3.2c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-0.7,0.2-1.2,0.2c-0.7,0-1.3-0.3-1.8-0.8c-0.5-0.5-0.8-1.3-0.8-2.4c0-1,0.2-1.8,0.7-2.5c0.5-0.6,1.1-1,1.9-1C8.7,115.1,9.1,115.3,9.5,115.5z M6.8,119.9c0.3,0.7,0.8,1,1.4,1c0.7,0,1.2-0.3,1.5-1c0.2-0.4,0.2-0.9,0.2-1.5c0-0.5-0.1-1-0.3-1.4c-0.3-0.6-0.8-0.9-1.5-0.9c-0.5,0-0.8,0.2-1.2,0.6c-0.3,0.4-0.5,1-0.5,1.8C6.6,119,6.7,119.5,6.8,119.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M13.7,115.3v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1h1.1v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H13.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M19.3,113h1.1v1.2h-1.1V113z M19.3,115.3h1.1v6.2h-1.1V115.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M25.8,115.5c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C25,115.1,25.4,115.2,25.8,115.5z M26.2,117.9c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H26.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M28.8,113.5h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2H28v-0.9h0.8V113.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M35.9,119.6c0,0.4,0.1,0.6,0.3,0.8c0.3,0.3,0.7,0.5,1.4,0.5c0.4,0,0.7-0.1,1.1-0.3s0.5-0.4,0.5-0.8c0-0.3-0.1-0.5-0.4-0.6c-0.2-0.1-0.5-0.2-0.9-0.3l-0.9-0.2c-0.5-0.1-0.9-0.3-1.2-0.4c-0.5-0.3-0.7-0.7-0.7-1.2c0-0.6,0.2-1.1,0.7-1.4s1-0.6,1.7-0.6c1,0,1.6,0.3,2.1,0.8c0.3,0.4,0.4,0.7,0.4,1.1h-1c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.3-0.7-0.4-1.3-0.4c-0.4,0-0.7,0.1-0.9,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.3,0.1,0.5,0.4,0.7c0.2,0.1,0.4,0.2,0.7,0.3l0.7,0.2c0.8,0.2,1.3,0.4,1.6,0.5c0.4,0.3,0.6,0.7,0.6,1.3c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-1.1,0.6-2,0.6c-0.9,0-1.6-0.2-2-0.6c-0.4-0.4-0.6-0.9-0.6-1.6H35.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M41.5,113.5h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V113.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M44.7,115.3h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V115.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M52.5,115.5c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C51.7,115.1,52.1,115.2,52.5,115.5z M52.9,117.9c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H52.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M59.2,115.5c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C58.3,115.1,58.8,115.2,59.2,115.5z M59.5,117.9c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H59.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M62.2,113.5h1.1v1.8h1v0.9h-1v4.1c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.1,0-0.2,0.1-0.4,0.1s-0.3,0-0.4,0c-0.5,0-0.8-0.1-1-0.4s-0.3-0.6-0.3-1v-4.2h-0.8v-0.9h0.8V113.5z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2354_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2355_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2382_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2383_',
            'class' : 'origins-highlight-area',
            'd' : 'M0.3,43.6V11.3c0-2.5,2-4.5,4.5-4.5H68c2.5,0,4.5,2,4.5,4.5v32.3H0.3z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2379_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2380_',
            'fill' : '#00B9ED',
            'd' : 'M65.7,104.4H6.5c-3.6,0-6.4-2.9-6.4-6.4V49.8c0-3.6,2.9-6.4,6.4-6.4h59.3c3.6,0,6.4,2.9,6.4,6.4V98C72.2,101.6,69.3,104.4,65.7,104.4z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2377_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2378_',
            'fill' : '#FDFCFF',
            'd' : 'M65.7,102.2H6.5c-3.6,0-6.4-2.9-6.4-6.4V45.9c0-3.6,2.9-6.4,6.4-6.4h59.3c3.6,0,6.4,2.9,6.4,6.4v49.9C72.2,99.3,69.3,102.2,65.7,102.2z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2371_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2374_',
            'fill' : '#DEE0E2',
            'd' : 'M72.2,94.8v2.9c0,2.5-2,4.5-4.5,4.5H4.5c-2.5,0-4.5-2-4.5-4.5v-2.9H72.2z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2365_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2366_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2370_',
            'fill' : '#004A7A',
            'points' : '31.5,13.3 28.3,13.3 29.9,11.7 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2364_',
            'y' : '74.5',
            'fill' : '#DEE0E2',
            'width' : '72.1',
            'height' : '16'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2363_',
            'y' : '81.7',
            'fill' : '#FDFCFF',
            'width' : '3.1',
            'height' : '1.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2360_',
            'x' : '15.5',
            'y' : '81.7',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '1.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2357_',
            'x' : '36.7',
            'y' : '81.7',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '1.2'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2356_',
            'x' : '56.6',
            'y' : '81.7',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '1.2'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2353_',
            'fill' : '#DEE0E2',
            'd' : 'M46.1,57.3v12.8c0,0.5-0.4,0.9-0.9,0.9h-8.4V57.3H46.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2352_',
            'fill' : '#DEE0E2',
            'd' : 'M68.3,39.4v28.8c0,1.6-1.3,2.8-2.8,2.8H51.7V39.4H68.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2350_',
            'fill' : '#DEE0E2',
            'd' : 'M3.3,39.4v28.8c0,1.6,1.3,2.8,2.8,2.8h13.8V39.4H3.3z'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2349_',
            'fill' : '#DEE0E2',
            'points' : '53.6,59.9 19.9,59.9 19.9,44.9 36.7,32.8 53.5,44.9 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2348_',
            'fill' : '#FDFCFF',
            'points' : '36.9,59.9 19.9,59.9 19.9,44.9 36.7,32.8 '
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2347_',
            'fill' : '#00B9ED',
            'd' : 'M35.5,10.9L19.9,22.2v22.8l15.6-11.3c0.7-0.5,1.7-0.5,2.4,0l15.6,11.3V22.2L37.9,10.9C37.2,10.4,36.2,10.4,35.5,10.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2346_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M19.9,41.5l15.6-11.3c0.7-0.5,1.7-0.5,2.4,0'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2345_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M19.9,38.3l15.6-11.3c0.7-0.5,1.7-0.5,2.4,0'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2344_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M19.9,35.2l15.6-11.3c0.7-0.5,1.7-0.5,2.4,0'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2343_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M19.9,32l15.6-11.3c0.7-0.5,1.7-0.5,2.4,0'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2342_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M19.9,28.9l15.6-11.3c0.7-0.5,1.7-0.5,2.4,0'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2341_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M19.9,25.7l15.6-11.3c0.7-0.5,1.7-0.5,2.4,0'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2340_',
            'fill' : '#FDFCFF',
            'd' : 'M42.5,21.6h25c0.5,0,1-0.4,1-1l0,0c0-0.5-0.4-1-1-1h-4.5c-0.5,0-1-0.4-1-1v-5.6c0-0.5-0.4-1-1-1H53c-0.5,0-1,0.4-1,1v1.7c0,0.5-0.4,1-1,1h-3.4c-0.5,0-1,0.4-1,1v0.8c0,0.5-0.4,1-1,1h-3.3c-0.6,0-1,0.5-1,1.1l0.1,1.1C41.6,21.2,42,21.6,42.5,21.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2339_',
            'fill' : '#004A7A',
            'd' : 'M36.7,33.3c0.4,0,0.8,0.1,1.2,0.4l15.6,11.3V22.2L37.9,10.9c-0.4-0.3-0.8-0.4-1.2-0.4L36.7,33.3z'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2338_',
            'fill' : '#FDFCFF',
            'points' : '36.8,72 19.9,72 19.9,64.3 28.4,58.1 36.8,64.3 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2336_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2337_',
            'fill' : '#00B9ED',
            'points' : '28.4,58.1 19.9,64.3 19.9,49.7 28.4,43.5 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2334_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2335_',
            'fill' : '#004A7A',
            'points' : '28.4,58.1 36.9,64.3 36.9,49.7 28.4,43.5 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2333_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'points' : '36.8,72 43.6,65.2 43.6,59.9 36.9,59.9 '
        }
    }, {
        'type' : 'polyline',
        'properties' : {
            'id' : 'XMLID_2332_',
            'fill' : '#A1ACB2',
            'points' : '36.9,49.8 43.6,54.3 43.6,59.9 36.9,59.9 36.9,49.7 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2331_',
            'x' : '38.8',
            'y' : '49.5',
            'fill' : '#00B9ED',
            'width' : '4.8',
            'height' : '4.8'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2330_',
            'fill' : '#004A7A',
            'points' : '43.6,54.3 38.8,54.3 38.8,51 43.6,54.2 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2329_',
            'x' : '46',
            'y' : '49.7',
            'fill' : '#00B9ED',
            'width' : '5.5',
            'height' : '10.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2328_',
            'x' : '23.1',
            'y' : '64.5',
            'opacity' : '0.33',
            'fill' : '#83929B',
            'width' : '10.6',
            'height' : '6.5'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2327_',
            'x' : '23.1',
            'y' : '63.8',
            'fill' : '#00B9ED',
            'width' : '10.6',
            'height' : '7.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2326_',
            'x' : '23.1',
            'y' : '63.8',
            'fill' : '#004A7A',
            'width' : '10.6',
            'height' : '1.2'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2325_',
            'fill' : '#31B7AF',
            'cx' : '39.7',
            'cy' : '64.4',
            'r' : '0.4'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2323_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2324_',
            'fill' : '#FDFCFF',
            'points' : '9.4,39.6 7.4,39.6 7.4,33.3 8.4,32.2 9.4,33.3 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2321_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2322_',
            'fill' : '#FDFCFF',
            'points' : '12.9,39.6 10.9,39.6 10.9,33.3 11.9,32.2 12.9,33.3 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2319_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2320_',
            'fill' : '#FDFCFF',
            'points' : '16.4,39.6 14.4,39.6 14.4,33.3 15.4,32.2 16.4,33.3 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2317_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2318_',
            'fill' : '#FDFCFF',
            'points' : '57.8,39.6 55.8,39.6 55.8,33.3 56.8,32.2 57.8,33.3 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2316_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'points' : '57.8,39.4 57.8,33.3 56.8,32.2 55.8,33.3 55.8,39.4 53.4,39.4 53.6,59.9 60.8,52.7 60.8,39.4 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2314_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2315_',
            'fill' : '#FDFCFF',
            'points' : '61.3,39.6 59.3,39.6 59.3,33.3 60.3,32.2 61.3,33.3 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2312_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2313_',
            'fill' : '#FDFCFF',
            'points' : '64.8,39.6 62.8,39.6 62.8,33.3 63.8,32.2 64.8,33.3 '
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2311_',
            'fill' : '#FDFCFF',
            'cx' : '28.5',
            'cy' : '61.7',
            'r' : '0.8'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2310_',
            'fill' : '#FDFCFF',
            'd' : 'M21.2,0v7.1c0,0.6,0.5,1.1,1.1,1.1h6.5c0.6,0,1.1,0.5,1.1,1.1v2.2c0,0.5,0.4,1,0.9,1l0,0c0.6,0.1,1.2-0.4,1.2-1V6.8c0-0.6-0.5-1.1-1.1-1.1h-1.5c-0.6,0-1.1-0.5-1.1-1.1V0'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2308_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2309_',
            'fill' : '#004A7A',
            'points' : '32.3,16.5 29.3,18.8 29.3,10.9 32.4,10.9 '
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2307_',
            'fill' : '#00B9ED',
            'cx' : '36.8',
            'cy' : '39.6',
            'r' : '2.5'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2306_',
            'fill' : '#004A7A',
            'd' : 'M36.8,37.1c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5V37.1z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2302_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2305_',
            'fill' : '#00B9ED',
            'points' : '28.4,58 19.8,64.2 19.8,49.7 28.4,43.5 '
        }
    }, {
        'type' : 'clipPath',
        'properties' : {
            'id' : 'XMLID_2_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2294_'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2301_',
            'fill' : '#FDFCFF',
            'cx' : '16.2',
            'cy' : '65.9',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2300_',
            'fill' : '#FDFCFF',
            'cx' : '16.6',
            'cy' : '59.2',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2299_',
            'fill' : '#FDFCFF',
            'cx' : '10.7',
            'cy' : '62.9',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2298_',
            'fill' : '#FDFCFF',
            'cx' : '16.8',
            'cy' : '50.1',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2297_',
            'fill' : '#FDFCFF',
            'cx' : '12.6',
            'cy' : '44.9',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2296_',
            'fill' : '#FDFCFF',
            'cx' : '11.1',
            'cy' : '54.7',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2293_',
            'fill' : '#FDFCFF',
            'cx' : '42.2',
            'cy' : '69',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2292_',
            'fill' : '#FDFCFF',
            'cx' : '44.6',
            'cy' : '63.3',
            'r' : '0.4'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2279_'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2291_',
            'fill' : '#A1ACB2',
            'cx' : '58.4',
            'cy' : '44.5',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2290_',
            'fill' : '#A1ACB2',
            'cx' : '58',
            'cy' : '51.2',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2289_',
            'fill' : '#FDFCFF',
            'cx' : '63.9',
            'cy' : '47.5',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2286_',
            'fill' : '#FDFCFF',
            'cx' : '57.7',
            'cy' : '60.3',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2285_',
            'fill' : '#FDFCFF',
            'cx' : '62',
            'cy' : '65.5',
            'r' : '0.4'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2280_',
            'fill' : '#FDFCFF',
            'cx' : '63.4',
            'cy' : '55.7',
            'r' : '0.4'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2275_',
            'fill' : '#004A7A',
            'points' : '24.2,70.9 23.1,70.9 23.1,63.8 24.2,64.4 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2255_',
            'fill' : '#004A7A',
            'points' : '51.6,51.2 48,51.2 46.6,49.7 52,48 51.6,49.7 '
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2253_',
            'x' : '45.5',
            'y' : '48',
            'fill' : '#FDFCFF',
            'width' : '6.5',
            'height' : '1.5'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2228_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2249_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'd' : 'M22.2,88.1c2.9,0,3-2.7,3-2.7h2.2l1.4-1.4c0,0,0-2.2,0-3.5c0-1.2-2.1-4.5-4.5-4.5s-0.6,0-0.6,0l-2.8-3.4h-9.1l-3.5,2.8l1,8.2l0.5,4.4c0,0,3.5,1.4,4.5-2.9l6.2-0.2L22.2,88.1z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2248_',
            'fill' : '#00B9ED',
            'd' : 'M24.7,85.3L7,81v-3.4h15c1.5,0,2.7,1.2,2.7,2.7V85.3z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2247_',
            'fill' : '#00B9ED',
            'd' : 'M7,77.6l4.1,1l9.2-1L18,74.1H9.6c-1.5,0-2.7,1.2-2.7,2.7V77.6z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2244_',
            'x' : '6.3',
            'y' : '80.5',
            'fill' : '#00B9ED',
            'width' : '19',
            'height' : '4.5'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2243_',
            'fill' : '#006FAF',
            'd' : 'M24.7,85.3H7v-3.4h14.3C23.1,81.9,24.7,83.4,24.7,85.3L24.7,85.3z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_2242_',
            'x' : '6.3',
            'y' : '85',
            'fill' : '#006FAF',
            'width' : '19',
            'height' : '1.4'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2238_',
            'fill' : '#006FAF',
            'd' : 'M7,81.9l4.1,1l9.2-1L18,78.5H9.6c-1.5,0-2.7,1.2-2.7,2.7V81.9z'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2237_',
            'fill' : '#006FAF',
            'cx' : '9.7',
            'cy' : '86.1',
            'r' : '1.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2235_',
            'fill' : '#FFFFFF',
            'cx' : '9.7',
            'cy' : '86.1',
            'r' : '0.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2233_',
            'fill' : '#006FAF',
            'cx' : '21.8',
            'cy' : '86.1',
            'r' : '1.9'
        }
    }, {
        'type' : 'circle',
        'properties' : {
            'id' : 'XMLID_2232_',
            'fill' : '#FFFFFF',
            'cx' : '21.8',
            'cy' : '86.1',
            'r' : '0.9'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2229_',
            'fill' : '#FFFFFF',
            'points' : '18,78.5 18,74.1 20.3,77.6 20.3,81.9 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2207_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2219_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'points' : '49.7,92.9 49.9,86.6 52.7,86.6 52.9,80.2 43.6,86.6 46.3,86.6 37.2,92.9 40.8,92.9 33.5,98 39.1,98 37.2,100.6 38.6,100.6 40.5,98 45.9,98 46.1,92.9 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2215_',
            'fill' : '#00B9ED',
            'points' : '39.7,85.2 42.7,85.2 37.7,78.1 32.7,85.2 35.7,85.2 30.8,92.1 34.8,92.1 30.8,97.7 37,97.7 37,100.6 38.6,100.6 38.6,97.7 44.6,97.7 40.6,92.1 44.6,92.1 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_2208_',
            'fill' : '#004A7A',
            'points' : '39.7,85.2 42.7,85.2 37.7,78.1 37.6,97.7 44.6,97.7 40.6,92.1 44.6,92.1 '
        }
    }]
}, {
    name : 'ruralArea',
    y : 290,
    p : [{
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M11.8,110.5h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V110.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M16.8,110.5v4.2c0,0.3,0,0.6,0.1,0.8c0.2,0.4,0.5,0.6,1,0.6c0.7,0,1.2-0.3,1.5-1c0.1-0.4,0.2-0.8,0.2-1.4v-3.1h1.1v6.3h-1l0-0.9c-0.1,0.2-0.3,0.4-0.5,0.6c-0.4,0.3-0.9,0.5-1.4,0.5c-0.9,0-1.5-0.3-1.8-0.9c-0.2-0.3-0.3-0.7-0.3-1.3v-4.3H16.8z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M22.5,110.5h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V110.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M29.8,113c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.6,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6c0.5-0.3,1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L29.8,113z M27.6,115.9c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C27.3,115.4,27.4,115.7,27.6,115.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M33.2,108.2h1.1v8.6h-1.1V108.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M42.5,113c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.6,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6c0.5-0.3,1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L42.5,113z M40.3,115.9c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C39.9,115.4,40,115.7,40.3,115.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M45.8,110.5h1v1.1c0.1-0.2,0.3-0.5,0.6-0.8s0.7-0.5,1.1-0.5c0,0,0.1,0,0.1,0s0.1,0,0.2,0v1.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.5,0-0.9,0.2-1.2,0.5s-0.4,0.7-0.4,1.2v3.6h-1.1V110.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M53.7,110.7c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.3,0.1,0.8,0.1,1.4h-4.6c0,0.6,0.2,1.2,0.4,1.5c0.3,0.4,0.7,0.6,1.3,0.6c0.5,0,1-0.2,1.3-0.5c0.2-0.2,0.3-0.5,0.4-0.7h1c0,0.2-0.1,0.5-0.3,0.8s-0.3,0.5-0.5,0.7c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.5,0.1-0.9,0.1c-0.8,0-1.4-0.3-2-0.9c-0.5-0.6-0.8-1.4-0.8-2.4c0-1,0.3-1.8,0.8-2.5c0.5-0.6,1.3-0.9,2.1-0.9C52.8,110.4,53.3,110.5,53.7,110.7z M54,113.2c0-0.5-0.1-0.8-0.3-1.1c-0.3-0.5-0.8-0.8-1.4-0.8c-0.5,0-0.9,0.2-1.2,0.5s-0.5,0.8-0.5,1.3H54z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'fill' : '#004A7A',
            'd' : 'M59.8,113c0.2,0,0.4-0.1,0.5-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.4-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-1.1-0.2c-0.6,0-0.9,0.1-1.2,0.4c-0.1,0.2-0.2,0.4-0.3,0.7h-1c0-0.8,0.3-1.3,0.8-1.6c0.5-0.3,1-0.5,1.7-0.5c0.7,0,1.3,0.1,1.8,0.4c0.5,0.3,0.7,0.7,0.7,1.3v3.6c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.3,0.1c0,0,0.1,0,0.2,0s0.1,0,0.2,0v0.8c-0.2,0-0.3,0.1-0.4,0.1s-0.2,0-0.4,0c-0.4,0-0.6-0.1-0.8-0.4c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2,0.3-0.5,0.5-0.9,0.7s-0.8,0.3-1.3,0.3c-0.6,0-1.1-0.2-1.4-0.5c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.6,0.2-1,0.5-1.4c0.4-0.3,0.8-0.5,1.4-0.6L59.8,113z M57.6,115.9c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,1.1-0.3c0.6-0.3,0.9-0.8,0.9-1.4v-0.8c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1l-0.6,0.1c-0.4,0.1-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.5-0.5,0.9C57.3,115.4,57.4,115.7,57.6,115.9z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1500_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1798_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1978_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2176_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2196_',
            'fill' : '#00B9ED',
            'd' : 'M65.7,97.6H6.5c-3.6,0-6.4-2.9-6.4-6.4V43c0-3.6,2.9-6.4,6.4-6.4h59.3c3.5,0,6.4,2.9,6.4,6.4v48.3C72.2,94.8,69.3,97.6,65.7,97.6z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2157_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2172_',
            'class' : 'origins-highlight-area',
            'd' : 'M0,41.3V23.1c0-2.2,1.8-4,4-4h6.1c2.2,0,4-1.8,4-4v-2.9c0-2.2,1.8-4,4-4h22.7c2.2,0,4-1.8,4-4l0,0c0-2.2,1.8-4,4-4h19.1c2.2,0,4,1.8,4,4v37.3H0z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_2005_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2155_',
            'fill' : '#FDFCFF',
            'd' : 'M65.7,95.4H6.5c-3.6,0-6.4-2.9-6.4-6.4V39.1c0-3.6,2.9-6.4,6.4-6.4h59.3c3.5,0,6.4,2.9,6.4,6.4v49.9C72.2,92.5,69.3,95.4,65.7,95.4z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2004_',
            'fill' : '#DEE0E2',
            'd' : 'M67.7,32.6v38.1c0,1.6-1.3,2.8-2.8,2.8H41.1V32.6H67.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_2001_',
            'fill' : '#DEE0E2',
            'd' : 'M5.3,32.6v38.1c0,1.6,1.3,2.8,2.8,2.8h22.5V32.6H5.3z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1986_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1997_',
            'y' : '77.5',
            'fill' : '#DEE0E2',
            'width' : '72.1',
            'height' : '10.7'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1995_',
            'y' : '82.4',
            'fill' : '#FDFCFF',
            'width' : '3.1',
            'height' : '0.8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1994_',
            'x' : '15.5',
            'y' : '82.4',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '0.8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1988_',
            'x' : '36.7',
            'y' : '82.4',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '0.8'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1987_',
            'x' : '56.6',
            'y' : '82.4',
            'fill' : '#FDFCFF',
            'width' : '8.7',
            'height' : '0.8'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1983_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'd' : 'M37.8,41L11.6,67.1l-0.2-0.7l5.2-5.2c-2-0.2-3.6-1.3-4.9-2.9l-1.6,1.6l-0.2-0.7l1.4-1.4c-0.2-0.3-0.4-0.6-0.5-0.9l-6.7,6L4,62.2l26.6-25.4c0,0,2.9-4,6.9-2.2C41.6,36.4,37.8,41,37.8,41z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1949_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1977_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'points' : '50.3,64.6 52.9,61.9 54.4,61.9 60,56.4 59.8,32.5 27.9,32.5 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1975_',
            'fill' : '#FFFFFF',
            'points' : '52.6,59.1 36.2,52.5 19.7,59.1 22.1,59.1 22.3,64.6 50.3,64.6 50.2,59.1 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1973_',
            'fill' : '#FDFCFF',
            'points' : '52.6,59.1 36.2,52.5 19.7,59.1 22.1,59.1 22.3,64.6 50.3,64.6 50.2,59.1 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1965_'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1972_',
            'x' : '30.5',
            'y' : '57.6',
            'fill' : '#00B9ED',
            'width' : '10.6',
            'height' : '7.1'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1970_',
            'x' : '30.5',
            'y' : '57.6',
            'fill' : '#004A7A',
            'width' : '10.6',
            'height' : '1.2'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1969_',
            'fill' : '#004A7A',
            'points' : '31.6,64.7 30.5,64.7 30.5,57.6 31.6,58.3 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1960_',
            'fill' : '#FFFFFF',
            'points' : '36.2,52.5 52.6,59.1 52.6,29.8 36.2,23.1 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1958_',
            'fill' : '#004A7A',
            'points' : '36.2,52.5 52.6,59.1 52.6,29.8 36.2,23.1 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1954_',
            'fill' : '#00B9ED',
            'points' : '19.7,59.1 36.2,52.5 36.2,23.1 19.7,29.8 '
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1952_',
            'fill' : '#05A4D2',
            'd' : 'M30.9,44.2l-11.4,10l-0.1-11.5l4.9-4.2c0,0,5.2-4.8,8.8-1.9S30.9,44.2,30.9,44.2z'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1801_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1802_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1940_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1942_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1948_',
            'fill' : '#004A7A',
            'd' : 'M3.9,43.2c0.2,0,0.3,0.1,0.3,0.2v19.2c0,0.1-0.1,0.2-0.3,0.2s-0.3-0.1-0.3-0.2V43.4C3.6,43.3,3.7,43.2,3.9,43.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1947_',
            'fill' : '#004A7A',
            'd' : 'M13.1,42.2c0.2,0,0.3,0.1,0.3,0.2v19.2c0,0.1-0.1,0.2-0.3,0.2s-0.3-0.1-0.3-0.2V42.3C12.8,42.2,12.9,42.2,13.1,42.2z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1945_',
            'fill' : '#00B9ED',
            'd' : 'M8.5,25.6c-2.8,0-5,1.9-5,4.2h0V56c0,1.6,2.2,2.9,5,2.9s5-1.3,5-2.9V29.8h0C13.5,27.5,11.3,25.6,8.5,25.6z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1943_',
            'fill' : '#004A7A',
            'd' : 'M8.5,58.9c2.8,0,5-1.3,5-2.9V29.8h0c0-2.3-2.2-4.2-5-4.2L8.5,58.9z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1891_',
            'fill' : '#004A7A',
            'd' : 'M11.1,47.7c0.2,0,0.3,0.1,0.3,0.2v19.2c0,0.1-0.1,0.2-0.3,0.2s-0.3-0.1-0.3-0.2V47.9C10.8,47.8,10.9,47.7,11.1,47.7z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1890_',
            'fill' : 'none',
            'stroke' : '#00B9ED',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,54.6c2.8,0,5-1.3,5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1889_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,54.6c-2.8,0-5-1.3-5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1888_',
            'fill' : 'none',
            'stroke' : '#00B9ED',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,49.7c2.8,0,5-1.3,5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1884_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,49.7c-2.8,0-5-1.3-5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1874_',
            'fill' : 'none',
            'stroke' : '#00B9ED',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,44.7c2.8,0,5-1.3,5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1860_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,44.7c-2.8,0-5-1.3-5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1854_',
            'fill' : 'none',
            'stroke' : '#00B9ED',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,39.8c2.8,0,5-1.3,5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1850_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,39.8c-2.8,0-5-1.3-5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1810_',
            'fill' : 'none',
            'stroke' : '#00B9ED',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,34.9c2.8,0,5-1.3,5-2.9'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1804_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'd' : 'M8.5,34.9c-2.8,0-5-1.3-5-2.9'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1754_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '19.7',
            'y1' : '32.6',
            'x2' : '36.2',
            'y2' : '25.9'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1745_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '19.7',
            'y1' : '36',
            'x2' : '36.2',
            'y2' : '29.4'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1672_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '19.7',
            'y1' : '39.4',
            'x2' : '36.2',
            'y2' : '32.8'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1669_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '19.7',
            'y1' : '42.8',
            'x2' : '36.2',
            'y2' : '36.2'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1666_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '19.7',
            'y1' : '46.3',
            'x2' : '36.2',
            'y2' : '39.6'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1661_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '19.7',
            'y1' : '49.7',
            'x2' : '36.2',
            'y2' : '43'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1636_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '19.7',
            'y1' : '53.1',
            'x2' : '36.2',
            'y2' : '46.5'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1633_',
            'fill' : 'none',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-miterlimit' : '10',
            'x1' : '19.7',
            'y1' : '56.5',
            'x2' : '36.2',
            'y2' : '49.9'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1510_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1518_'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1615_'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1624_',
            'fill' : '#CCD5DA',
            'd' : 'M61.1,40.2l7.5-7.5H66l-6.3,6.3C59.7,39.1,60.8,40.2,61.1,40.2z'
        }
    }, {
        'type' : 'rect',
        'properties' : {
            'id' : 'XMLID_1621_',
            'x' : '59.2',
            'y' : '30.4',
            'fill' : '#004A7A',
            'width' : '1.9',
            'height' : '9.8'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1620_',
            'fill' : '#00B9ED',
            'd' : 'M63.8,18.5c0.8-0.9,1.2-2,1.2-3.2c0-1.7-0.8-3.1-2.1-4c0.8-0.7,1.2-1.7,1.2-2.9c0-2.2-1.8-4-4-4s-4,1.8-4,4c0,1.1,0.5,2.2,1.2,2.9c-1.3,0.9-2.1,2.3-2.1,4c0,1.2,0.5,2.4,1.2,3.2c-1.9,1.2-3.1,3.3-3.1,5.7c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7C66.9,21.8,65.6,19.7,63.8,18.5z'
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1618_',
            'fill' : '#004A7A',
            'd' : 'M60.2,30.9c3.7,0,6.7-3,6.7-6.7c0-2.4-1.3-4.5-3.1-5.7c0.8-0.9,1.2-2,1.2-3.2c0-1.7-0.8-3.1-2.1-4c0.8-0.7,1.2-1.7,1.2-2.9c0-2.2-1.8-4-4-4V30.9z'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1517_',
            'fill' : 'none',
            'stroke' : '#00B9ED',
            'stroke-width' : '0.7',
            'stroke-linecap' : 'square',
            'stroke-miterlimit' : '10',
            'x1' : '59.4',
            'y1' : '28.8',
            'x2' : '64.5',
            'y2' : '23.7'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1516_',
            'fill' : 'none',
            'stroke' : '#00B9ED',
            'stroke-width' : '0.7',
            'stroke-linecap' : 'square',
            'stroke-miterlimit' : '10',
            'x1' : '57.5',
            'y1' : '20',
            'x2' : '62.5',
            'y2' : '14.9'
        }
    }, {
        'type' : 'line',
        'properties' : {
            'id' : 'XMLID_1511_',
            'fill' : '#006FAF',
            'stroke' : '#004A7A',
            'stroke-width' : '0.7',
            'stroke-linecap' : 'square',
            'stroke-miterlimit' : '10',
            'x1' : '57.1',
            'y1' : '20.4',
            'x2' : '60.5',
            'y2' : '23.8'
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1506_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1509_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'points' : '66.4,86.1 66.6,79.8 69.4,79.8 69.6,73.4 60.3,79.8 63.1,79.8 54,86.1 57.6,86.1 50.2,91.2 55.8,91.2 53.9,93.8 55.3,93.8 57.2,91.2 62.7,91.2 62.8,86.1 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1508_',
            'fill' : '#00B9ED',
            'points' : '56.4,78.4 59.4,78.4 54.4,71.3 49.4,78.4 52.5,78.4 47.6,85.3 51.5,85.3 47.6,90.9 53.8,90.9 53.8,93.8 55.3,93.8 55.3,90.9 61.3,90.9 57.3,85.3 61.3,85.3 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1507_',
            'fill' : '#004A7A',
            'points' : '56.4,78.4 59.4,78.4 54.4,71.3 54.3,90.9 61.3,90.9 57.3,85.3 61.3,85.3 '
        }
    }, {
        'type' : 'g',
        'properties' : {
            'id' : 'XMLID_1502_'
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1505_',
            'opacity' : '0.33',
            'fill' : '#7E8D93',
            'points' : '26.3,86.1 26.5,79.8 29.3,79.8 29.5,73.4 20.2,79.8 22.9,79.8 13.8,86.1 17.4,86.1 10.1,91.2 15.7,91.2 13.8,93.8 15.2,93.8 17.1,91.2 22.6,91.2 22.7,86.1 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1504_',
            'fill' : '#00B9ED',
            'points' : '16.3,78.4 19.3,78.4 14.3,71.3 9.3,78.4 12.4,78.4 7.5,85.3 11.4,85.3 7.5,90.9 13.7,90.9 13.7,93.8 15.2,93.8 15.2,90.9 21.2,90.9 17.2,85.3 21.2,85.3 '
        }
    }, {
        'type' : 'polygon',
        'properties' : {
            'id' : 'XMLID_1503_',
            'fill' : '#004A7A',
            'points' : '16.3,78.4 19.3,78.4 14.3,71.3 14.2,90.9 21.2,90.9 17.2,85.3 21.2,85.3 '
        }
    }, {
        'type' : 'path',
        'properties' : {
            'id' : 'XMLID_1501_',
            'fill' : '#FDFCFF',
            'd' : 'M24.9,20.3h20.2c0.4,0,0.8-0.4,0.8-0.8l0,0c0-0.4-0.4-0.8-0.8-0.8h-3.6c-0.4,0-0.8-0.4-0.8-0.8v-4.5c0-0.4-0.4-0.8-0.8-0.8h-6.6c-0.4,0-0.8,0.4-0.8,0.8v1.4c0,0.4-0.4,0.8-0.8,0.8H29c-0.4,0-0.8,0.4-0.8,0.8V17c0,0.4-0.4,0.8-0.8,0.8h-2.6c-0.5,0-0.8,0.4-0.8,0.9l0.1,0.9C24.1,19.9,24.5,20.3,24.9,20.3z'
        }
    }]
}];

export default areas;